import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { AtLeastAdministratorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';

import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { ProductOverviewComponent } from './components/product-overview/product-overview.component';
import { ProductComponent } from './product.component';
import { ProductOverviewResolver } from './resolvers/product-overview.resolver';

export const productRoutes: Routes = [
  {
    path: 'product',
    component: ProductComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdministratorRoleGuard]),
    children: [
      {
        path: '',
        component: ProductOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard, AtLeastAdministratorRoleGuard]),
        data: { name: 'product-overview' },
        resolve: {
          data: mapToResolve(ProductOverviewResolver),
        },
      },
      {
        path: 'create',
        component: ProductDetailComponent,
        canActivate: mapToCanActivate([LocationGuard, AtLeastAdministratorRoleGuard]),
        data: { name: 'product-detail' },
      },
      {
        path: 'edit/:id',
        component: ProductDetailComponent,
        canActivate: mapToCanActivate([LocationGuard, AtLeastAdministratorRoleGuard]),
        data: { name: 'product-detail' },
      },
    ],
  },
];
